const question = {
    yes: { point: [2] },
    no: { point: [1] },
};

export default question;
